<template>
  <div>
      <div v-if="searchType == 'add'" class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div>
              <template v-for="(e, ind) in searchConfig.basic" >
                <span :key="e.TYPE + ind">
                  <div class="layui-inline"><label class="layui-search-label">{{e.NAME}}</label></div>
                  <div class="layui-inline" :style="{width: e.WIDTH ? e.WIDTH + 'px' : '190px'}">
                    <input
                      type="text"
                      v-if="e.TYPE === 'input'"
                      v-model="tableObj.queryObject[e.FIELD]"
                      autocomplete="off"
                      class="layui-input"
                      :placeholder="e.PLACEHOLDER"/>

                    <layui-date
                      v-if="e.TYPE === 'date'"
                      placeholder="请输入时间"
                      v-model="tableObj.queryObject[e.FIELD]"
                    />

                    <layui-daterange
                      v-if="e.TYPE === 'daterange'"
                      placeholder="请输入时间"
                      v-model="tableObj.queryObject[e.FIELD]"
                    />

                    <layui-datetime
                      v-if="e.TYPE === 'datetime'"
                      placeholder="请输入时间"
                      v-model="tableObj.queryObject[e.FIELD]"
                    />

                    <layui-datetimerange
                      v-if="e.TYPE === 'datetimerange'"
                      placeholder="请输入时间"
                      v-model="tableObj.queryObject[e.FIELD]"
                      />

                    <layui-treeselect
                      v-if="e.TYPE === 'treeselect'"
                      :ref="e.ref"
                      :table-name="e.tableName"
                      :text-field="e.textField"
                      :value-field="e.valueField"
                      :id-field="e.idField"
                      :parent-field="e.parentField"
                      :show-check="e.showCheck"
                      :init-expand-level="e.expandLevel"
                      :max-load-level="e.maxLoadLevel"
                      :show-parent-label="e.showParentLabel"
                      v-model="tableObj.queryObject[e.FIELD]"
                      @treeSelect="e.treeSelect"
                      :condition="e.queryCondition"
                    ></layui-treeselect>

                    <layui-select
                      v-if="e.TYPE === 'select'"
                      :ref="e.ref"
                      v-model="tableObj.queryObject[e.FIELD]"
                      :table-name="e.tableName"
                      :text-field="e.textField"
                      :value-field="e.valueField"
                      :queryCondition="e.queryCondition"
                      :enableSearch="e.enableSearch"
                      :sort="e.sort"
                      :showNullOption="true"
                    />

                    <layui-select
                      v-if="e.TYPE === 'select-solt'"
                      v-model="tableObj.queryObject[e.FIELD]"
                      :init-value = e.initValue
                      :showNullOption="true">
                      <option v-for="j in e.options" :key="j.value" :value="j.value">{{ j.text }}</option>
                    </layui-select>

                    <layui-radio
                      v-if="e.TYPE === 'radio'"
                      v-model="tableObj.queryObject[e.FIELD]">
                        <input
                          type="radio"
                          v-for="j in e.options"
                          :key="j.value"
                          :value="j.value"
                          :title="j.title" />
                    </layui-radio>

                    <layui-check
                      v-if="e.TYPE === 'check'"
                      v-model="tableObj.queryObject[e.FIELD]"
                      :initData="e.options">
                    </layui-check>
                  </div>
                </span>
              </template>
              <button class="layui-btn layuiadmin-btn-list" title="查询" @click="search()" v-show="!searchConfig.showSearch">查 询</button>
              <button class="layui-btn fold-flag advanced" title="高级搜索" @click="handleChangeAdvance" v-show="searchConfig.advanced && searchConfig.advanced.length">展开高级搜索</button>
              <div style="float: right;">
                <button class="layui-btn refresh" title="刷新列表" @click="reset()">
                  <i class="layui-icon">&#xe669;</i>
                  刷 新
                </button>
                <button class="layui-btn refresh batch" title="批量操作" v-show="searchConfig.showBatch">
                  批量操作
                  <i class="layui-icon">&#xe625;</i>
                </button>
                <layui-exportexcel  ref="export"></layui-exportexcel>
                <slot />
              </div>
          </div>
      </div>
      <!-- <div v-else class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div class="layui-form-item">
              <div class="layui-inline">
                  <input class="layui-input"  autocomplete="off" placeholder="搜索" v-model="value">
              </div>
              <button class="layui-btn layuiadmin-btn-list" title="查询" @click="search()">查 询</button>
              <button class="layui-btn fold-flag" title="高级搜索" >高级搜索</button>
              <div style="float: right;">
                <button class="layui-btn refresh" title="刷新" @click="reset()">
                  <i class="layui-icon">&#xe669;</i>
                  刷 新
                </button>
                <button class="layui-btn refresh" title="批量操作" @click="reset()">
                  批量操作
                  <i class="layui-icon">&#xe625;</i>
                </button>
              </div>
          </div>
      </div> -->
      <advanced-query ref="advancedObj" v-show="advancedShow" :tableObj="tableObj" :advanced="searchConfig.advanced" @advancedQuery="handleChangeAdvance"></advanced-query>
  </div>
</template>

<script>
export default {
  props: {
    searchType: {
      type: String,
      default: () => ''
    },
    // 引用table对象
    tableObj: {
      type: Object,
      default: () => {
        return {
          queryObject: {}
        }
      }
    },
    // 查询集合模型
    searchConfig: {
      type: Object,
      default: () => {
        return {
          basic: [], //基础查询
          advanced: [] //高级查询
        }
      }
    },
    exportTemplate: {
      type: String,
      default: ()=> ''
    },
    exportType: {
      type: String,
      default: ()=> ''
    }
  },
  data () {
    return {
      value: '',
      advancedShow : false,
    }
  },
  mounted(){
    let that = this;

    this.advancedObj = this.$refs.advancedObj;
    let element = this.el = $(this.$el);
    let batchId =  this.uuid();

    //批量操作
    let batchEl = element.find('.batch');
    batchEl.attr("id", batchId);

    this.layui.dropdown.render({
      elem:  '#' + batchId,
      data: [
        { title: '导出excel',id: 1},
        { title: '批量删除',id: 2 },
      ],
      click: function(obj) {
          if(obj.id === 1) {
            if (that.exportType === '1') {
              // 如果exportType===1,自定义导出，调用父组件方法
              that.$emit('exportExcel')
            } else {
              that.export();
            }
          }else if(obj.id === 2) {
            that.tableObj.delCheckedRows()
          }
      }
    });

  },
  methods: {
    handleChangeAdvance(){
      this.advancedShow = !this.advancedShow
      $('.advanced').html(this.advancedShow ? '收起高级搜索' : '展开高级搜索')
    },
    search () {
      this.tableObj.search();
    },
    reset () {
      this.advancedShow = false;
      this.advancedObj.clear();
      this.tableObj.reset();
    },
    add (value) {
      this.$emit('addOrder', value)
    },
    export(){
      var exportObj = this.$refs.export;
      exportObj.setTemplateName(this.exportTemplate);
      exportObj.export(this.tableObj);
    }
  }
}
</script>
<style scoped>
.layui-search-label {
    padding: 9px 5px;
}
.core .layui-form .layui-inline{
  margin-right: 0!important;
}
.layui-inline >>> .layui-icon-date{
    top: -2px !important;
}
</style>





// WEBPACK FOOTER //
// src/components/common/pub-search.vue